'use client'

import { APIProvider } from '@vis.gl/react-google-maps'
import { ReactNode } from 'react'

const PLACES_LIBRARIES: string[] = ['places']

export const PlacesApiProvider = ({ children }: { children?: ReactNode }) => (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY ?? ''} libraries={PLACES_LIBRARIES}>
        {children}
    </APIProvider>
)
